


































































/*
  sendMessageTeacherInfoManage, sendMessagePropositionTeacherEmploy 发送短信息
  sendNoticeTeacherInfoManage 发送通知
*/
import { Vue, Component, Prop } from "vue-property-decorator";
import { Tree as ElTree } from "element-ui";
//引入教师信息管理中的接口
import {
  sendMessageTeacherMaintain,
  sendNoticeTeacherMaintain
} from "../../../../api/teacherMaintain";
//引入命题教师聘用的接口
import { sendMessagePropositionTeacherEmploy } from "../../../../api/propositionTeacherEmploy";

@Component({
  name: "teacherInfoManageDetail"
})
export default class extends Vue {
  @Prop(Object) treeVos!: object; //数据
  @Prop(String) fromPage!: string; //父组件页面
  @Prop(String) msgType!: string; //发送短信息 or 发送通知
  private checkAll: boolean = false;
  private defaultProps: object = {
    children: "nodes",
    label: "name"
  };
  private dialogFormTitle: string = ""; //弹窗标题
  private msg: string = ""; //短信内容
  private choosedTeacherIds: string[] = []; //选中的教师id

  created() {
    this.dialogFormTitle = this.msgType === "msg" ? "发送短信息" : "发送通知";
  }

  //将获取到的treeVos整理成渲染需要的格式
  get treeData() {
    return [this.treeVos];
  }

  //点击“全选/取消全选”的处理
  private checkAllHandle(v: boolean) {
    if (v) {
      (this.$refs.mailListTree as ElTree).setCheckedNodes(this.treeData);
    } else {
      (this.$refs.mailListTree as ElTree).setCheckedNodes([]);
    }
  }

  //点击复选框，判断是否全选
  private checkHandle(current, checkedObj) {
    //选中的key个数
    let checkedLength = checkedObj.checkedKeys.length;
    //tree的总key数
    let totalLength = (this.$refs.mailListTree as any).treeItems.length;
    //个数相等，代表全选
    checkedLength === totalLength
      ? (this.checkAll = true)
      : (this.checkAll = false);
  }

  //节点选中状态发生变化时
  private checkChange(current, status) {
    //current 是当前节点对象  status是当前节点是否选中
    //如果没有nodes，说明是教师节点
    if (!current.nodes) {
      if (status) {
        //被选中
        this.choosedTeacherIds.push(current.id);
      } else {
        //不选中
        this.choosedTeacherIds.forEach((i, index) => {
          if (i === current.id) {
            this.choosedTeacherIds.splice(index, 1);
          }
        });
      }
    }
  }

  //点击“发送”的处理
  private async sendHandle() {
    if (this.choosedTeacherIds.length <= 0) {
      this.$message.warning("请先勾选！");
      return false;
    }
    if (!this.msg) {
      this.$message.warning("请输入内容！");
      return false;
    }
    let params = {
      ids: this.choosedTeacherIds,
      msg: this.msg
    };

    const loading = this.loading();
    try {
      if (this.fromPage === "teacherMaintain") {
        //教师信息管理页面
        if (this.msgType === "msg") {
          //发送短信息
          await sendMessageTeacherMaintain(params);
        } else {
          //发送通知
          await sendNoticeTeacherMaintain(params);
        }
      }
      // 但其实不用下面这段逻辑
      else if (this.fromPage === "propositionTeacherEmploy") {
        //命题教师聘用页面
        if (this.msgType === "msg") {
          //发送短信息
          await sendMessagePropositionTeacherEmploy(params);
        }
      }
      this.$message.success("发送成功");
      //关闭弹窗
      (this.$parent as any).showSendMessage = false;
      //操作成功，重新获取列表
      (this.$parent as any).getData();
    } catch (error) {
      // this.$message.error(error || "发送失败");
      this[`$message`]({
        type: "error",
        message: error!.mesg ? error!.mesg : error
      });
    } finally {
      loading.close();
    }
  }

  private loading() {
    return this.$loading({
      lock: true,
      text: '发送短信中...',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
  };
}
